export default __webpack_public_path__ + "static/media/doctor-review.e0133b86.svg";